module.exports = __webpack_public_path__ + "static/media/supportMessagesSent_10_15.820771f1.png";